<template>
  <div class="container">
    <video
      v-show="!videoError"
      autoplay
      muted
      loop
      class="video-background"
      @error="handleVideoError"
    >
      <source src="@/assets/video/video_bg2.mp4" type="video/mp4" />
      <!-- 如果需要支持其他格式 -->
      <!-- <source src="@/assets/video/background.webm" type="video/webm"> -->
    </video>

    <!-- 视频无法播放时显示的替代图片 -->
    <img
      v-show="videoError"
      src="@/assets/images/video_img.png"
      class="image-background"
    />

    <div class="content">
      <!-- <Header/> -->
      <Content>
        <Main />
      </Content>
    </div>
  </div>
</template>

<script>
import { Content, Main } from "./components";
export default {
  components: {
    Content,
    Main,
  },
  data() {
    return {
      videoError: false,
    };
  },
  methods: {
    handleVideoError() {
      this.videoError = true;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.video-background,
.image-background {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  object-fit: cover;
}

.content {
  position: relative;
  z-index: 1;
  // 你可以在这里添加内容区域的样式
}
</style>
